module.exports = __webpack_public_path__ + "static/3-e3e23314f502b98685097e047be81f9b.png";